/* ================================================== *\
 * Model to store SVG polygon and paths from a residence.
\* ================================================== */

import { Model } from '@vuex-orm/core';

export default class Shape extends Model {
  static entity = 'shapes';

  static fields() {
    return {
      id: this.uid(),

      illustration: this.attr(null),
      polygon: this.attr(null),
      path: this.attr(null),

      // Relationship
      shapeable_id: this.attr(null),
      shapeable_type: this.attr(null),
      shapeable: this.morphTo('shapeable_id', 'shapeable_type'),
    };
  }
}
